// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { saveState } from 'src/lib/utils';
import store from 'src/store/Store';
import { notificationReceived, saveFCMToken } from 'src/store/apps/slices/NotificationSlice';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCxTOWLlSCHHFSWQFDyg_D15evPTYcxL4I',
  authDomain: 'jo-jo-ims.firebaseapp.com',
  projectId: 'jo-jo-ims',
  storageBucket: 'jo-jo-ims.firebasestorage.app',
  messagingSenderId: '302929066926',
  appId: '1:302929066926:web:2656c493d10436c68ba63f',
  measurementId: 'G-HQQ8KSREP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const vapidKey = "BGjuvTCz2J5dlbMdWUFMwO5WrlrlojlUoUzDo68TLC5ZRunHHYf5AYKnAZEF_p4Jk9L0DIhUsVPhu2GgplQmpWE";

// Keep messaging as a promise that resolves when ready
let messagingPromise = null;

const getMessagingInstance = async () => {
  if (messagingPromise) {
    return messagingPromise;
  }
  
  messagingPromise = isSupported().then((supported) => {
    if (supported) {
      const messagingInstance = getMessaging(app);
      
      // Set up onMessage listener only once
      onMessage(messagingInstance, (payload) => {
        store.dispatch(notificationReceived());
      });
      
      return messagingInstance;
    } else {
      console.warn('Firebase messaging is not supported in this browser.');
      return null;
    }
  }).catch((err) => {
    console.error('Error checking messaging support: ', err);
    return null;
  });
  
  return messagingPromise;
};

export const generateToken = async () => {
  try {
    const messaging = await getMessagingInstance();
    
    if (!messaging) {
      console.log('Messaging not supported or failed to initialize');
      return;
    }

    // Check notification permission first
    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('Notification permission not granted');
        return;
      }
    } else if (Notification.permission === 'denied') {
      console.log('Notification permission denied');
      return;
    }

    const fcmToken = await getToken(messaging, { vapidKey });
    if (fcmToken) {
      store.dispatch(saveFCMToken({ fcm_token: fcmToken }));
      saveState('fcmToken', fcmToken);
      console.log('FCM Token generated:', fcmToken);
      return fcmToken;
    } else {
      console.log('No registration token available.');
      return null;
    }
  } catch (err) {
    console.error('An error occurred while retrieving token: ', err);
    return null;
  }
};

// Export the messaging instance getter
export { getMessagingInstance };